import { StoreState } from '@/redux/types';
import { getDraft } from './getDraft';

export const getCurrentAppearance = (state: StoreState) => getDraft(state).appearance;
